import React, { useEffect, useState } from 'react';
import Style from './style.module.css';
import Kiss from '../../asset/kiss.png';
import smile from '../../asset/smile.png';

function Task() {
  const [kissMe, setKissMe] = useState(new Array(9).fill(false));
  const [count, setCount] = useState(0);


  function setKissVisiblity(idx,isVisible){

    setKissMe((prev)=>{
      const newArr = [...prev];
      newArr[idx] = isVisible;
      return newArr;
    });
  }

  useEffect(()=>{
    const intrevel = setInterval(()=>{
      const randomNumber  = Math.floor(Math.random() * kissMe?.length);
      setKissVisiblity(randomNumber,true);
      setTimeout(()=>{
        setKissVisiblity(randomNumber,false);
      },900)

    },1000);

    return()=>{
      clearInterval(intrevel);
    }

  },[kissMe])

  const handleClick = (idx)=>{
      if(!kissMe[idx]) return
      setKissVisiblity(idx,false);
      setCount((prev)=> prev + 1 );
     
  }
  console.log("kissme",kissMe);
  return (
    <div className='container-fluid'>

      {/* Score 0 */}
      <div className='row  '>
        <div className='col-sm-12 col-md-12 col-lg-12  d-flex justify-content-center '>
          <h1>Score {count}</h1>
        </div>
      </div>

      {/* Image section  */}

      <div className='row d-flex justify-content-center m-5'>
        {
          kissMe?.map((kiss,idx)=>(
            <div key={idx}  className='col-sm-6 bg-warning border  border-black col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center'>
               <img onClick={()=>{handleClick(idx)}}  style={{width : '100px', height : '100px'}} src={kiss ? Kiss : smile} alt='kiss'/>
            </div>
          ))
        }   
      </div>

      
    </div>
  )
}

export default Task